import React from 'react'
import './Contact.scss'
import contact_img from '../assets/contact.png'
import mail_icon from '../assets/mail_icon.png'
import mobile_icon from '../assets/mobile_icon.png'
import linkedin_icon from '../assets/linkedin_icon.png'
import github_icon from '../assets/github_icon.png'


const Contact = () => {

    const items = [
        {
            icon: mail_icon,
            text: "saifadriskhan@gmail.com",
            link: "#"
        },
        {
            icon: mobile_icon,
            text: "+91 9324087263",
            link: "#"
        },
        {
            icon: linkedin_icon,
            text: "Saif Khan",
            link: "https://www.linkedin.com/in/saif-khan-67a8ba1ba/"
        },
        {
            icon: github_icon,
            text: "saifkhan29",
            link: "https://github.com/saifkhan29"
        },
    ]


  return (
    <div className="contact_main_cont pb-5">
        <div className="container py-5 mb-2">
            <div className="row d-flex flex-column-reverse flex-md-row">
                <div className="col-12 col-md-6 d-flex justify-content-center align-items-center">
                    <div  className="contact_items_cont">
                        {
                            items.map((item,idx) => (
                        <div data-aos="fade-up"  key={idx} className="items my-4 d-flex justify-content-start align-items-center">
                            <img className='me-3' src={item.icon} alt="" />
                            <h3><a href={item.link} rel="noreferrer" target="_blank">{item.text}</a></h3>
                        </div>

                            ))
                        }
                    </div>
                </div>
                <div data-aos="fade-up" className="col-12 col-md-6">
                    <img className='w-75 my-4 my-md-0' src={contact_img} alt="" />
                </div>
            </div>
        </div>
    </div>
  )
}

export default Contact